import { TemplateQuestion, TemplateQuestionsTypes } from './Fillgrid'

enum TemplateNumber {
  NONE,
  ABSOLUTE,
  GROUPING
}

enum StrictDateType {
  MINUTE = 1,
  HOUR = 2,
  DAYS = 3
}
export enum SortTypes {
  ASC = 'ASC',
  DESC = 'DESC'
}
class StrictDate {
  online: boolean
  range: number
  type: StrictDateType
}
export class Template {
  id: number
  name: string
  label: string
  domain: number
  project: number
  version: number
  enabled: boolean
  webEnabled: boolean
  migrated: boolean
  locked: boolean
  subTemplate: boolean
  downloads: number
  numbering: TemplateNumber
  hidden: boolean
  break: boolean
  exclusive: boolean
  keep: number
  autoUpdate: number
  blockFillsDeletion: boolean // if is active, mobile user can not delete assigned fills
  blockFillsCreation: boolean // if is active, mobile user can not create new fills
  pdfQuestion: string
  fillLocation: string
  visitedLocation: string
  strictDate: StrictDate
  creationDate: Date
  updateDate: Date
  idents: string[] // idents[0] = ident0, idents[1] ident1, idents[2] = ident2
  questions: TemplateQuestion[]
  blockedQuestions: string[]

  /**
   * Validate if the template is inactive,
   * this is neither enabled nor web enabled
   *
   * @param template to validate
   */
  static isInactive (template: Template): boolean {
    return !template.enabled && !template.webEnabled
  }

  static getQuestionByName (questionName: string, questions: TemplateQuestion[]): TemplateQuestion | undefined {
    for (const question of questions) {
      if ((question.type === TemplateQuestionsTypes.GROUP || question.type === TemplateQuestionsTypes.ADDRESS) && question.questions) {
        return this.getQuestionByName(questionName, question.questions)
      } else if (question.id === questionName) {
        return question
      }
    }
    return undefined
  }
}

export class TemplateFilters {
  sort: Array<string>
  sortType: Array<SortTypes>
  domain: number
  project: number
  name: string
  version: number
  enabled: boolean
  webEnabled: boolean
  migrated: boolean
  locked: boolean
  fieldsValidation: boolean
  subTemplate: boolean
}
